















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbTooltip, mdbRow, mdbCol } from '@folky-tools/mdbvue';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { GetBusinessStatusKpiOutputDto, kpisService, usersService } from '@/services';
import BusinessVisitsStatus from '@/components/businesses/BusinessVisitsStatus.vue';

@Component({ components: { mdbBtn, mdbTooltip, mdbRow, mdbCol, BusinessVisitsStatus, AppSysBar: () => import('@/components/shared/AppSysBar.vue') } })
export default class BusinessKpisView extends Vue {
    private businessStatusKpi: GetBusinessStatusKpiOutputDto = new GetBusinessStatusKpiOutputDto();

    private async mounted(): Promise<void> {
        this.businessStatusKpi = await kpisService.getBusinessStatusKpi(+this.$route.params.id);
        this.$root.$emit('change-active-page', 'views.businesses.businessKpisView.title', this.$route.query.businessName ? this.$route.query.businessName : '...');

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.BusinessKpis,
                scope: UserActionScopeType.Details,
                entityId: +this.$route.params.id
            })
        );
    }
}
